import {
  addOptionalNullableToSchema,
  emailSchema,
  internationalStateSchema,
  optionalNullableNameSchema,
  phoneSchema,
  requiredErrorMessage,
  requiredNameSchema,
  zipSchema,
} from '@common/schema';
import * as yup from 'yup';

export const addEmergencyContactSchema = yup.object().shape({
  first_name: requiredNameSchema,
  middle_name: optionalNullableNameSchema,
  last_name: requiredNameSchema,
  relationship: yup
    .string()
    .oneOf(
      Object.values([
        'Spouse',
        'Domestic partner',
        'Daughter',
        'Son',
        'Sibling',
        'Other family member',
        'Friend',
        'Other non-family member',
      ]),
    )
    .required(requiredErrorMessage),
  google_places_id: addOptionalNullableToSchema(yup.string()),
  street: optionalNullableNameSchema,
  suite: optionalNullableNameSchema,
  state: internationalStateSchema,
  city: optionalNullableNameSchema,
  zip_code: addOptionalNullableToSchema(zipSchema),
  country: optionalNullableNameSchema,
  email: addOptionalNullableToSchema(emailSchema),
  phone_number: phoneSchema.required(requiredErrorMessage),
  phone_type: yup
    .string()
    .oneOf(Object.values(['Home', 'Cell', 'Business']))
    .required(requiredErrorMessage),
});
